<template>
    <div class="tab-area">
        <div class="information" ref="formContainer">
            <div class="table" v-if="statistics.length" id="current-game">
                <div class="row header">
                    <div class="col">#</div>
                    <div class="col">Team name</div>
                    <div class="col">Date in</div>
                    <div class="col">Gems</div>
                    <div class="col" v-if="!sites.scoring">Speed</div>
                    <div class="col" style="width: 20%;"></div>
                </div>
                <template>
                    <div class="row" v-for="(game, index) in statistics" :key="'game-' + game.id">
                        <div class="col">{{ (index + 1) }}</div>
                        <div class="col">{{ game.name }}</div>
                        <div class="col">{{ game.time_in | datetime('DD/MM/YYYY HH:mm') }}</div>
                        <div class="col">{{ Object.values(game.gems).reduce((a, b) => a + b, 0) }}</div>
                        <div class="col" v-if="!sites.scoring">{{ game.speed | speed_rating }}</div>
                        <div class="col text-right text-nowrap">
                            <button class="btn green-btn" @click="downloadStatistic(game.team_id, 'false')">Simple PDF</button>
                            <button class="ml-15 btn green-btn" @click="downloadStatistic(game.team_id, 'true')">PDF</button>
                        </div>
                    </div>
                </template>
            </div>
            <template v-else>
                <div class="information">
                    <div class="no-active-message mb-50">
                        <h2>Statistics is empty</h2>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

    import config from "../modules/config";

    import {mapState, mapGetters} from 'vuex';

    import Downloader from 'js-file-downloader';

    import mapValues from 'lodash/mapValues';

    export default {

        name: "History",

        data(){
            return {
                server_time: null,
                games: {},
                statistics: [],
                timeout: null
            };
        },

        metaInfo () {
            return {
                title: 'Team games history',
            }
        },

        mounted(){
          const self = this;
          let loader = this.$loading.show({container: self.$refs.formContainer});
          self.getStatisticT().then(() => {
              loader.hide();
          });
        },

        beforeDestroy(){
            clearTimeout(this.timeout);
        },

        methods: {

            getStatisticT(){
                return this.viewStatistic().then(server_time => {
                    this.server_time = server_time;
                    this.timeout = setTimeout(() => {
                        if(this.server_time === null || this.activeGames.length > 0){
                            this.getStatisticT();
                        }
                    }, 2000);
                });
            },

            http_params(format = 'json'){
                return {
                    dateFrom: this.$moment().subtract(3, 'days').format('YYYY-MM-DD'),
                    //dateTo:   this.$moment().format('YYYY-MM-DD'),
                    status:   [config.status.FINISH, config.status.ARCHIVE, config.status.PAUSE, config.status.ACTIVE],
                    format:   format,
                    from:     this.server_time,
                    'team-games': true,
                };
            },

            getStatistic(format = 'json'){
                return new Promise((resolve, reject) => {
                    this.$http.get('games', {params: this.http_params(format), responseType: format}).then(resp => {
                        resolve(resp.data);
                    }).catch(err => {
                        reject(err);
                    });
                });
            },

            downloadStatistic(team, background = 'true'){
                const self = this;
                let loader = self.$loading.show({container: self.$refs.formContainer});
                let params = {
                    team: team,
                    background: background,
                };
                self.$http.get('print/team-pdf', {params: params}).then(data => {
                    new Downloader({
                        url: data.data.url,
                    });
                    loader.hide();
                });
            },

            viewStatistic(){
                const self = this;
                return self.getStatistic().then(resp => {
                    //self.games = {};
                    if(resp.games.length){
                        resp.games.forEach(game => {
                            let team = self.$isObject(self.games['team-' + game.team_id]) ? self.games['team-' + game.team_id] : {};
                            self.games = {
                                ...self.games,
                                ['team-' + game.team_id]: {
                                    ...game,
                                    gems: {
                                        ...(self.$isObject(team.gems) ? self.games['team-' + game.team_id].gems : {}),
                                        [game.id]: game.gems
                                    },
                                    speed_rating: {
                                        ...(self.$isObject(team.speed) ? self.games['team-' + game.team_id].speed : {}),
                                        [game.id]: {
                                            speed: game.speed_rating,
                                            speed_rating: game.speed_rating,
                                            server_active_time_in: game.server_active_time_in
                                        }
                                    },
                                    name: game.team.name + ' team',
                                }
                            };
                        });
                    }
                    return resp.server_time;
                });
            }
        },
        watch: {
            server_time(server_time) {
                this.statistics = Object.values(this.games).map(game => {
                    game.speed = Object.values(mapValues(game.speed_rating, (v, i) => {
                        if(game.status === config.status.ACTIVE){
                            return Math.round((game.gems[i] / (this.$moment(server_time).unix() - this.$moment(v.server_active_time_in).unix())) * 3600);
                        }
                        return v.speed_rating;
                    }));
                    game.speed = Math.round(game.speed.reduce((a, b) => a + b, 0) / game.speed.length);
                    return game;
                }).sort(function (a, b) {
                    if (a.team_id > b.team_id) {
                        return -1;
                    }
                    if (a.team_id < b.team_id) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
        computed: {
            ...mapGetters({
                activeGames: 'games/activeGames',
            }),
            ...mapState(['sites']),
        },
    }
</script>

<style scoped>

</style>